import React, { memo, useMemo, useState } from 'react';

const defaultWorlkerUrl = /* @__PURE__ */ new URL(
  '@slope/navmesh/navmesh-worker.js',
  import.meta.url,
);

import {
  NavMeshGeneratorContext,
  NavMeshGeneratorContextValue,
  NavMeshGeneratorResult,
  NavMeshGeneratorInternalContext,
  NavMeshInternalContextValue,
} from './NavMeshGeneratorContext';

const defaultCache = /* @__PURE__ */ new Map<string, NavMeshGeneratorResult>();

export interface NavMeshGeneratorProviderProps {
  children: React.ReactNode;
  workerUrl?: string | URL;
  cache?: Map<string, NavMeshGeneratorResult>;
}

export const NavMeshGeneratorProvider: React.FC<NavMeshGeneratorProviderProps> = memo(
  ({ children, workerUrl = defaultWorlkerUrl, cache = defaultCache }) => {
    const [ctx, setContext] = useState<NavMeshGeneratorContextValue | null>({
      navMesh: null,
      query: null,
      success: false,
      intermediates: null,
    });

    const value = useMemo<NavMeshInternalContextValue>(() => {
      return {
        worker: new Worker(workerUrl),
        cache,
        setContext,
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workerUrl.toString(), cache, setContext]);

    return (
      <NavMeshGeneratorInternalContext value={value}>
        <NavMeshGeneratorContext value={ctx}>{children}</NavMeshGeneratorContext>
      </NavMeshGeneratorInternalContext>
    );
  },
);
